import { combineReducers } from 'redux';

import dailyBriefDataReducer from './dailyBriefDataReducer';
import dailyBriefUiReducer from './dailyBriefUiReducer';

export default combineReducers({
  data: dailyBriefDataReducer,
  ui: dailyBriefUiReducer,
});
